<p-dialog header="Retrieving prediction" [modal]="true" [closable]="false" [(visible)]="waiting"
          xmlns="http://www.w3.org/1999/html">
  <div style="background-color: white;">
    <img src="/assets/img/loading.gif" alt="Loading...">
  </div>
</p-dialog>
<p-dialog header="SDG AI model details" [modal]="true" [closable]="true" [(visible)]="showingMoreInfos"
          dismissableMask="true">
  <div style="background-color: white; color: black; text-align: left; max-width: 1200px; padding: 10px;">

    <h2 class="results-heading">SDG AI model details</h2>
    <p>The first three models are based on an industry standard AI model pretrained on 104 languages, <a
      href="https://github.com/google-research/bert/blob/master/multilingual.md">multilingual-BERT</a> (mBERT). We
      trained this mBERT model further using English text data to predict whether a text fragments belongs to exactly
      one SDG, you may get reasonable results also for texts written in other Germanic languages. To train the mBERT
      model, we used two different SDG definitions, one from Aurora, one from Elsevier.</p>

    <p>The first two <a href="https://doi.org/10.5281/zenodo.5603019">Aurora AI models have been trained and
      evaluated</a> using <a href="https://doi.org/10.5281/zenodo.5205672">1.4 million abstracts</a> using the SDG
      definition according to the <a href="https://aurora-network-global.github.io/sdg-queries/">Aurora SDG queries</a>,
      those have been <a href="https://doi.org/10.5281/zenodo.4917107">rigorously tested by 244 researchers</a> and and
      iteratively redesigned to aim for a high precision outcome, to reduce 'garbage data' for training an AI . <a
        href="https://doi.org/10.5281/zenodo.5603019">[read our report to learn more]</a></p>

    <div *ngFor="let model of appGlobals.availableModels">
      <h4>{{model.name}}</h4>
      <p [innerHTML]="model.description"></p>
    </div>

  </div>
</p-dialog>
<p-toast></p-toast>
<div class="banner">
  <div class="jumbotron" style="text-align: center">
    <h1>SDG classification service</h1>
    <p>Classify a given text according to the Sustainable Development Goals</p>
  </div>
</div>
<div class="container-fluid content-container">
  <div class="content">
    <h1 class="results-heading">Text and model</h1>
    <div class="grid">
      <div class="sm:col-12 md:col-10 lg:col-8 xl:col-6 md:col-offset-1 lg:col-offset-2 xl:col-offset-3">
        <div class="grid flex">
          <div class="col-12">
            <h3 class="text-input">Step 1: Input your Text</h3>
            <p>Type in title and abstract or just paste your text fragment in the abstract field:</p>
            <div class="field grid">
              <label class="col-fixed" style="width:100px" for="abstract-input">Abstract</label>
                <textarea style="width: 100%" rows="6"
                  class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  id="abstract-input" pInputTextarea [(ngModel)]="text"
                  (input)="reset()"></textarea>
            </div>
          </div>
          <div class="col-12">
            <h3 class="text-input">Step 2: Select your SDG AI model</h3>
            <p>You can select from 4 different models (<a style="cursor: pointer;" (click)="showingMoreInfos = true;">for
              more Details, please click here</a>):
            </p>
            <div class="field grid">
              <label class="col-fixed" style="width:100px" for="model-select">Model</label>
              <p-dropdown style="width: 100%" [options]="modelOptions" [(ngModel)]="classificationModel" optionLabel="name"
                          optionValue="value" (onChange)="reset()"
                          id="model-select"></p-dropdown>
            </div>
            <p>You selected: {{modelDescriptions[classificationModel]}}</p>
          </div>
          <div class="col-12">
            <h3 class="text-input">Step 3: Run the model</h3>
            <p>Press "classify" to run your text through the selected SDG AI model:</p>
            <div class="centered">
              <button pButton type="button" label="Classify" class="p-button-raised classify-button"
                      (click)="classifySingleAbstract()"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="classified" class="content">
    <h1 class="results-heading">Results of classification</h1>
    <div class="grid">
      <div class="sm:col-12 md:col-10 lg:col-8 xl:col-6 md:col-offset-1 lg:col-offset-2 xl:col-offset-3">
        <p>Showing all SDGs and their calculated probability in descending order.</p>
        <div class="grid"
             style="background-color: white; color: #1a171b; text-align: left; margin: 20px; border-radius: 20px; vertical-align: middle;">

          <div id="sdg-wheel" class="sm:col-6 md:col-4 lg:col-4 xl:col-4" style="width: 30%; text-align: center;">
            <p-chart type="doughnut" [data]="data" [options]="chartOptions" [style]="{'margin': '30px'}"></p-chart>
            <a [href]="getUrl()" target="_blank">View data in JSON format</a>
          </div>
          <div class="sm:col-6 md:col-8 lg:col-8 xl:col-8">

            <div class="grid">
              <div *ngFor="let prediction of classification.predictions" class="sm:col-12 md:col-6 lg:col-4 xl:col-4">
                <div class="grid">
                  <div class="col-3">
                    <a [href]="'https://sdgs.un.org/goals/goal' + prediction.sdg.code" target="_blank">
                      <img width="30px" [src]="'/assets/img/sdg_icon_' + prediction.sdg.code + '.png'">
                    </a>
                  </div>
                  <div class="col-9">
                      <span><b>{{prediction.sdg.label}}:</b> {{prediction.sdg.name}}
                        ({{prediction.prediction | percent:'1.0-0' }})</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="classified" class="content">
    <h1 class="results-heading">Embed this badge into your web page</h1>
    <div class="grid">
      <div class="sm:col-12 md:col-10 lg:col-8 xl:col-6 md:col-offset-1 lg:col-offset-2 xl:col-offset-3">
        <p>Select the size of the SDG badge:</p>
        <div class="field grid">
          <label class="col-fixed" style="width:100px" for="sdg-wheel-size">Wheel size</label>
          <p-inputNumber [(ngModel)]="wheelSize" mode="decimal" [showButtons]="true" inputId="sdg-wheel-size" [min]="50"
                         [max]="500" [step]="50" (ngModelChange)="buildHtmlSnippet()">
          </p-inputNumber>
        </div>

        <p>Copy the following html snippet to the place where you want to display the badge:</p>
        <div class="grid">
          <div class="sm:col-12 col-11">
            <blockquote class="blockquote" style="background-color: lightgrey;">
              <pre><code>{{htmlCode}}</code></pre>
            </blockquote>
          </div>
          <div class="sm:col-12 col-1" style="vertical-align: middle">
            <div><a (click)="copy(htmlCode)"><i class="pi pi-copy" style="font-size: 2rem;"></i></a></div>
          </div>
        </div>
        <p>Add the following JavaScript snippet to the bottom of your page:</p>
        <div class="grid">
          <div class="sm:col-12 col-11">
            <blockquote class="blockquote" style="background-color: lightgrey">
              <pre><code>{{scriptCode}}</code></pre>
            </blockquote>
          </div>
          <div class="sm:col-12 col-1" style="vertical-align: middle">
            <div>
              <a (click)="copy(scriptCode)"><i class="pi pi-copy" style="font-size: 2rem;"></i></a>
            </div>
          </div>
        </div>
        <div>
          <p>To display this SDG-badge:</p>
          <div style="text-align: left;" [innerHTML]="htmlCode | safe: 'html'">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
